export default "__VITE_ASSET__D$etxYf9__"